export default function() {
    return {
        user: {
            name: '',
            email: '',
            birthDate: '',
            phone: '',
            gender: '',
            rg: '',
            cpf: '',
            zipCode: '',
            state: '',
            city: '',
            address: '',
            addressNumber: '',
            addressNeighbourhood: '',
            contactName: '',
            contactPhone: '',
            image: ''
        },
        availableGenders: [
            {
                value: 'F',
                label: 'Feminino'
            },
            {
                value: 'M',
                label: 'Masculino'
            },
            {
                value: 'O',
                label: 'Outros'
            }
        ],
        ufList: [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO'
        ],
        datePickerConfig: {
            nextMonthCaption: 'Próximo mês',
            prevMonthCaption: 'Mês anterior',
            weekdays: [
                'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
            ],
            months: [
                'Janeiro', 'Fevereiro', 'Março', 'Abril',
                'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ]
        }
    }
}
